import * as React from 'react'; 
import { arrayOf, shape, string, oneOf, array, any, func, object, number, bool} from 'prop-types';

import {HABIT_TYPE} from '../../features/Habit/constants';
import HabitItem from '../HabitItem';
import './style.css';
import HabitCheckbox from '../HabitCheckbox';
import { getDates } from '../../utils/get-dates';
import {dayToLabel} from '../../utils/day-to-label';
import {isHabitCompleted} from '../../utils/is-habit-completed';
import {getWeeklyCompletedByHabit, getWeeklyPercentageByHabit} from '../../utils/get-weekly-percentage';
import ProgressBar from '../ProgressBar';

export default function HabitCalendar(props){

  const dates = getDates(props.startDate, props.endDate);

  if(!props.habits.length){
    return <div className="text-center border-t pt-5">
      Be better yourself, add a habit!
    </div>
  }

  return <div>

    {props.viewType == 'GRID' ? 
      <table className="habit-calendar pt-5 block">
        <thead>
          <tr className="">
            <th className="w-64"> </th>
            {dates.map((date, index) => {
               return <th key={index}>
                 {dayToLabel(date.getDay())} <br/> 
                 <small>
                   {date.getDate()}/{date.getMonth() + 1}
                 </small>
               </th>
            })}
            <th></th>
          </tr>
        </thead>
        <tbody>
          {props.habits.filter(habit => habit.created_at.setHours(0,0,0,0) <= new Date(props.endDate.getTime()).setHours(0,0,0,0)).map( habit => {
            return <tr key={habit.uuid} className="">
             <td>
               <HabitItem onDelete={props.onDeleteHabit} habit={habit}/>
             </td>
             {dates.map((date) => {

               const completed = isHabitCompleted(habit.id, date, props.checklists);

               return <td key={date.getDate() + '/' + date.getMonth()} className="text-center pt-2">
                 {habit.recurrence.map(r => r.toString()).find( day => day == date.getDay() && habit.created_at.setHours(0,0,0,0) <= new Date(props.endDate.getTime()).setHours(0,0,0,0)) 
                   ? <HabitCheckbox completed={completed} /> 
                   : null} 
               </td>
              })}
              <td className="px-2 text-center">
                <small>
                  {getWeeklyCompletedByHabit(habit, props.startDate, props.checklists)}/{habit.recurrence.length}
                </small>
              </td>
            </tr> 

          })}
        </tbody>
      </table>
    : null}

    {props.viewType == 'PROGRESS' ?
      <div>
          {props.habits.filter(habit => habit.created_at.setHours(0,0,0,0) <= new Date(props.endDate.getTime()).setHours(0,0,0,0)).map( habit => {
            return <div key={habit.id} className="flex py-1">
              <div className="w-1/3">
                <HabitItem habit={habit} onDelete={props.onDeleteHabit}/>
              </div>
              <div className="w-2/3">
                <ProgressBar 
                  size="large"
                  percentage={getWeeklyPercentageByHabit(habit, props.startDate, props.checklists)} 
                />
              </div>
            </div>
          })}
      </div>
      : null
    }

  </div>
}

HabitCalendar.defaultProps = {
  habits: [],
  checklists:{},
  viewType: 'GRID'
};



HabitCalendar.propTypes = {
  habits: arrayOf(shape({
    name: string,
    type: oneOf([HABIT_TYPE.DO, HABIT_TYPE.DONT]), 
    recurrence: array,
    id: number,
    created_at: object,
    completed: bool
  })),
  viewType: oneOf(['GRID', 'PROGRESS']),
  checklists: shape({[string]: any}),
  onDeleteHabit: func
}
